import type { ReactNode } from 'react';
import type { LinkLikeProps } from './LinkComponent';

/** The default LinkComponent: a plain anchor. The app substitutes its router link. */
export function PlainLink({ href, children, className, ...rest }: LinkLikeProps): ReactNode {
  return (
    <a href={href} className={className} aria-label={rest['aria-label']} title={rest['title']}>
      {children}
    </a>
  );
}
